import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSquareBehindSquare4"><Path fillRule="evenodd" clipRule="evenodd" d="M8 8V3.75C8 2.7835 8.7835 2 9.75 2H20.25C21.2165 2 22 2.7835 22 3.75V14.25C22 15.2165 21.2165 16 20.25 16H16V20.25C16 21.2165 15.2165 22 14.25 22H3.75C2.7835 22 2 21.2165 2 20.25V9.75C2 8.7835 2.7835 8 3.75 8H8ZM9.75 16C8.7835 16 8 15.2165 8 14.25V9H3.75C3.33579 9 3 9.33579 3 9.75V20.25C3 20.6642 3.33579 21 3.75 21H14.25C14.6642 21 15 20.6642 15 20.25V16H9.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare4;
